const projectConfig = {
  tryvisa: {
    // Project Settings
    brandName: 'TryVisa',
    port: 3030,
    url: 'tryvisa.com',
    domain: 'tryvisa.com',

    // Favicon Configuration
    favicon: {
      appleTouchIcon: '/favicon/apple-touch-icon.png',
      favicon32: '/favicon/favicon-32x32.png',
      favicon16: '/favicon/favicon-16x16.png',
      browserConfig: '/favicon/browserconfig.xml',
    },

    // Contact Information
    supportPhone: '+919266863989',
    supportPhoneFormatted: '+91 9266863989',
    supportEmail: 'info@tryvisa.com',
    supportWhatsapp: 'https://wa.me/919266863989',
    whatsappUpdateProfile:
      'https://wa.me/919266863989?text=Hey,%20I%20need%20to%20update%20my%20profile%20details',
    whatsappError:
      'https://wa.me/919266863989?text=Hey,%20I%am%20getting%20an%20error%20on%20your%20dashboard',

    // URLs
    privacyPolicyUrl: 'https://tryvisa.com/privacy-policy',
    termsUrl: 'https://tryvisa.com/terms',
    demoBookUrl: 'https://calendar.app.google/meeting/tryvisa',
    emailSender: 'noreply@tryvisa.com',
    careEmail: 'care@tryvisa.com',
    logoUrl: 'https://tryvisa.com/logo/logo_single.png',
    websiteUrl: 'https://tryvisa.com',
    get dashboardUrl() {
      const env = process.env.REACT_APP_ENV || 'prod';
      return env === 'dev' || env === 'local' ? 'https://dev.tryvisa.com' : 'https://tryvisa.com';
    },

    // Theme
    theme: {
      primaryColor: '#000000',
      secondaryColor: '#ffffff',
    },
  },
  agent: {
    // Project Settings
    brandName: 'TryVisa Agent',
    port: 3031,
    url: 'agent.tryvisa.com',
    domain: 'agent.tryvisa.com',

    // Favicon Configuration
    favicon: {
      appleTouchIcon: '/favicon/agent/apple-touch-icon.png',
      favicon32: '/favicon/agent/favicon-32x32.png',
      favicon16: '/favicon/agent/favicon-16x16.png',
      browserConfig: '/favicon/agent/browserconfig.xml',
    },

    // Contact Information
    supportPhone: '+919878896758',
    supportPhoneFormatted: '+91 9878896758',
    supportEmail: 'agent@tryvisa.com',
    supportWhatsapp: 'https://wa.me/919878896758',
    whatsappUpdateProfile:
      'https://wa.me/919878896758?text=Hey,%20I%20need%20to%20update%20my%20profile%20details',
    whatsappError:
      'https://wa.me/919878896758?text=Hey,%20I%am%20getting%20an%20error%20on%20your%20dashboard',

    // URLs
    privacyPolicyUrl: 'https://agent.tryvisa.com/privacy-policy',
    termsUrl: 'https://agent.tryvisa.com/terms-conditions',
    demoBookUrl: 'https://calendar.app.google/meeting/tryvisaagent',
    emailSender: 'noreply@tryvisa.com',
    careEmail: 'agent-care@tryvisa.com',
    logoUrl: 'https://agent.tryvisa.com/logo/logo-full.png',
    websiteUrl: 'https://agent.tryvisa.com',
    get dashboardUrl() {
      const env = process.env.REACT_APP_ENV || 'prod';
      return env === 'dev' || env === 'local'
        ? 'https://dev.agent.tryvisa.com'
        : 'https://agent.tryvisa.com';
    },

    // Theme
    theme: {
      primaryColor: '#000000',
      secondaryColor: '#ffffff',
    },
  },
};

// Determine which project is running based on the current URL
const getCurrentProject = () => {
  // Check if we're in a browser environment
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    if (currentHost.includes('agent.')) return 'agent';
    if (currentHost.includes('tryvisa.com')) return 'tryvisa';
  }

  // Fallback to port-based detection for development
  const port = process.env.PORT || '3030';
  return port === '3031' ? 'agent' : 'tryvisa';
};

// Export current project configuration
export const currentProject = getCurrentProject();
export const config = projectConfig[currentProject];

// Export individual brand configurations
export const TRYVISA = projectConfig.tryvisa;
export const AGENT = projectConfig.agent;

// Export helper functions
export const getBrandByDomain = () => {
  if (typeof window === 'undefined') return DEFAULT_BRAND;

  const { hostname, port } = window.location;

  // Check if we're in a production or development environment
  if (hostname === 'agent.tryvisa.com' || hostname === 'dev.agent.tryvisa.com') return AGENT;
  if (hostname === 'tryvisa.com' || hostname === 'dev.tryvisa.com') return TRYVISA;

  // For local development, check the port
  if (
    ['localhost', '127.0.0.1', '0.0.0.0'].includes(hostname) ||
    /^192\.168\.|^10\.|^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname)
  ) {
    return port === '3031' ? AGENT : TRYVISA;
  }

  // Default to TRYVISA if no match found
  return DEFAULT_BRAND;
};

// Default brand for server-side rendering or static contexts
export const DEFAULT_BRAND = TRYVISA;

export default config;
